'use client'

import {type CustomAssetSlide} from 'yet-another-react-lightbox'
import {HgLightbox} from '~/design-system/hg/components/HgWYSIWYG/Article/_components'

type DatoWYSIWYGLightboxProps = {
  index: number
  slides: CustomAssetSlide[]
  isLightboxOpen: boolean
  closeLightbox: () => void
}

export const DatoWYSIWYGLightbox = ({
  index,
  slides,
  isLightboxOpen,
  closeLightbox,
}: DatoWYSIWYGLightboxProps) => {
  return (
    <>
      <HgLightbox
        index={index}
        slides={slides}
        isOpen={isLightboxOpen}
        closeLightbox={closeLightbox}
      />
    </>
  )
}
